import { useQuery } from "@tanstack/react-query";
import apiClient from "../client";

interface PortalSettingsResponse {
  membershipsEnabled: boolean;
  portfolioBuilderEnabled: boolean;
  portfolioTrackerEnabled: boolean;
}

/** Set per environment, and only changed by a release, so read once per visit. */
export const usePortalSettings = () =>
  useQuery({
    queryKey: ["portal-settings"],
    queryFn: async () =>
      (await apiClient.get<PortalSettingsResponse>("/portal-settings")).data,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
  });

/** False until the answer arrives, so nothing about memberships flashes up where they're hidden. */
export const useMembershipsEnabled = (): boolean =>
  usePortalSettings().data?.membershipsEnabled === true;

/** False until the answer arrives, as for memberships. */
export const usePortfolioBuilderEnabled = (): boolean =>
  usePortalSettings().data?.portfolioBuilderEnabled === true;

/** False until the answer arrives, as for memberships. */
export const usePortfolioTrackerEnabled = (): boolean =>
  usePortalSettings().data?.portfolioTrackerEnabled === true;
